var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "sidebar-mobile-menu", attrs: { id: "mobile-menu" } },
    [
      _c(
        "ul",
        { staticClass: "sidebar-mobile-menu__links" },
        [
          _vm._l(_vm.menuItems, function(item, index) {
            return _c("NavMenuMobileItem", {
              key: index,
              attrs: { item: item, "class-prefix": "sidebar-mobile-menu" }
            })
          }),
          _vm._v(" "),
          _vm._m(0)
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "sidebar-mobile-menu__link-item" }, [
      _c("a", { attrs: { href: "/logout/" } }, [
        _c(
          "div",
          {
            staticClass:
              "sidebar-mobile-menu__link-icon sidebar-mobile-menu__signout"
          },
          [_c("i", { staticClass: "fa fa-sign-out-alt" })]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "sidebar-mobile-menu__link" }, [
          _vm._v("Sign out")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }